import WeddingsGiftConfigure from './WeddingsGiftConfigure';

export default WeddingsGiftConfigure;
